import React from "react";
import Modal from "../../Modal/Modal";

const InputPopup = ({ label, style = { padding: "20px 0" }, children }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <div style={style}>
        <button
          type="button"
          onClick={() => setOpen(true)}
          style={{ padding: "10px", fontWeight: "bold" }}
        >
          {label}
        </button>
      </div>

      <Modal open={open}>
        <div
          style={{
            padding: "20px",
          }}
        >
          {children}

          <button
            type="button"
            style={{ padding: "5px 10px", marginBottom: "10px" }}
            onClick={() => setOpen(false)}
          >
            OK
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default InputPopup;
